import React from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Container
} from "react-bootstrap";
import "./EditDistrict.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class EditDistrict extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        districtName: this.props.ItemList ? this.props.ItemList.name : null,
        id: this.props.ItemList ? this.props.ItemList.id : null,
        stateId: this.props.ItemList ? this.props.ItemList.stateId.id : null,
        latitude: this.props.ItemList ? this.props.ItemList.geo[0] : null,
        longitude: this.props.ItemList ? this.props.ItemList.geo[1] : null,

      }
    };

    this.editDistrict = this.editDistrict.bind(this);
    this.selectCategry = this.selectCategry.bind(this);
    this.onChangehandler = this.onChangehandler.bind(this);
  }

  editDistrict() {
    const Data = this.state.value;

    if (Data.stateId !== "" && Data.districtName !== "") {
      this.props.editDistrict(Data);
      this.props.closeEditModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        ...this.state.value,
        districtName: nextProps.ItemList.name,
        id: nextProps.ItemList.id,
        stateId: nextProps.ItemList.stateId && nextProps.ItemList.stateId.id,
        latitude: nextProps.ItemList && nextProps.ItemList.geo[0],
        longitude: nextProps.ItemList && nextProps.ItemList.geo[1],
      }
    });
  }
  selectCategry = e => {
    this.setState({ value: { ...this.state.value, stateId: e.target.value } });
  };
  onChangehandler = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "districtName") {
      this.setState({
        value: { ...this.state.value, districtName: value }
      });
    } else if (name === "latitude") {
      this.setState({ value: { ...this.state.value, latitude: value } });
    } else if (name === "longitude") {
      this.setState({ value: { ...this.state.value, longitude: value } });
    }
  };

  closeEditModel = () => {
    this.props.closeEditModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showEditModel}
          onHide={this.closeEditModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>District</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Container>
                <Row>
                  <Col lg={12}>
                    <div>
                      <Form>
                        <Row>


                          <Col lg={6} md={12} sm={12} xs={12}>
                            <Container>
                              <Row>
                                <Form.Group
                                  controlId="state"
                                  style={{ width: "100%" }}
                                >
                                  <Form.Label>State</Form.Label>
                                  <div style={{ width: "100%" }}>
                                    <select style={{ width: "100%" }}
                                      onChange={this.selectCategry}
                                      className="districtSelect"
                                    >
                                      {this.props.stateList &&
                                        this.props.stateList.map(
                                          (item, i) =>
                                            this.state.value.stateId === item.id && (
                                              <option key={i} value={item.id}>
                                                {item.name}
                                              </option>
                                            )
                                        )}
                                    </select>
                                  </div>
                                </Form.Group>
                              </Row>
                              <Row>
                                <Form.Group
                                  controlId="latitude"
                                  style={{ width: "100%" }}
                                >
                                  <Form.Label>Latitude</Form.Label>
                                  <Form.Control
                                    type="text"
                                    autoComplete="off"
                                    name="latitude"
                                    value={this.state.value.latitude}
                                    onChange={this.onChangehandler}
                                  />
                                </Form.Group>
                              </Row>
                            </Container>
                          </Col>

                          <Col lg={6} md={12} sm={12} xs={12}>
                            <Container>
                              <Row>
                                <Form.Group controlId="name" style={{ width: "100%" }}>
                                  <Form.Label>Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="districtName"
                                    autoComplete="off"
                                    value={this.state.value.districtName}
                                    onChange={this.onChangehandler}
                                  />
                                </Form.Group>
                              </Row>
                              <Row>
                                <Form.Group controlId="longitude" style={{ width: "100%" }}>
                                  <Form.Label>Longitude</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="longitude"
                                    autoComplete="off"
                                    value={this.state.value.longitude}
                                    onChange={this.onChangehandler}
                                  />
                                </Form.Group>
                              </Row>
                            </Container>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button
              type="submit"
              onClick={this.editDistrict}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditDistrict;
